import Api from "./Api";

const endpoint = "/singpause";
export default {
    getSingleiterInYear(school_year, show_inactive = true) {
        show_inactive = show_inactive ? 1 : 0;
        return Api.fetchData(endpoint + "/singleiter/list", {
            school_year,
            show_inactive
        });
    },
    getSingleiterInYearPDF(school_year, show_inactive = true) {
        show_inactive = show_inactive ? 1 : 0;
        return Api.fetchData(endpoint + "/singleiter/list/print", {
            school_year,
            show_inactive
        });
    },
    getSingleiterInYearExport(school_year, show_inactive = true) {
        show_inactive = show_inactive ? 1 : 0;
        return Api.fetchData(endpoint + "/singleiter/list/export", {
            school_year,
            show_inactive
        });
    },
    getKlassenForSingleiter(id) {
        return Api.fetchData(endpoint + "/klassen/singleiter/" + id);
    },
    getKlassenForSingleiterInYear(id, school_year) {
        return Api.fetchData(endpoint + "/klassen/singleiter/" + id, {
            school_year
        });
    },
    getHonorarForSingleiterInYear(id, school_year) {
        return Api.fetchData(
            endpoint + "/klassen/singleiter/" + id + "/honorar/year",
            { school_year }
        );
    },
    getHonorarForSingleiterAtDate(id, date) {
        return Api.fetchData(
            endpoint + "/klassen/singleiter/" + id + "/honorar/month",
            { date }
        );
    },
    getKlassenForSchuleInYear(id, school_year) {
        return Api.fetchData(endpoint + "/klassen/schulen/" + id, {
            school_year
        });
    },
    getHonorarForSchuleInYear(id, school_year) {
        return Api.fetchData(
            endpoint + "/klassen/schulen/" + id + "/honorar/year",
            { school_year }
        );
    },
    getHonorarForSchuleAtDate(id, date) {
        return Api.fetchData(
            endpoint + "/klassen/schulen/" + id + "/honorar/month",
            { date }
        );
    },
    getSchoolYears() {
        return Api.fetchData(endpoint + "/schuljahre");
    },
    getContactsForSingleiter(id, school_year) {
        return Api.fetchData(endpoint + "/kontakte/singleiter/" + id, {
            school_year
        });
    },
    getContactsForSchule(id, school_year) {
        return Api.fetchData(endpoint + "/kontakte/schulen/" + id, {
            school_year
        });
    },
    getSchools() {
        return Api.fetchData(endpoint + "/schulen");
    },
    getSchoolsInYear(school_year) {
        return Api.fetchData(endpoint + "/schulen/list", { school_year });
    },
    getSchoolsInYearPDF(school_year) {
        return Api.fetchData(endpoint + "/schulen/list/print", { school_year });
    },
    getConcertsForSingleiter(id) {
        return Api.fetchData(endpoint + "/konzerte/singleiter/" + id);
    },
    getOGSForSchule(id, school_year) {
        return Api.fetchData(endpoint + "/ogs/schulen/" + id, { school_year });
    },
    getMeta(mitglied_id, key) {
        return Api.fetchData(
            endpoint + "/meta/" + key + "/mitglied/" + mitglied_id
        );
    },
    getSingleiterContractById(contract_id) {
        return Api.fetchData(endpoint + "/klassen/contract/" + contract_id);
    },
    getMultipleSingleiterContractByIds(contract_ids) {
        return Api.putData(endpoint + "/klassen/contract", contract_ids);
    },
    putKlassen(id, data, school_year) {
        return Api.putData(endpoint + "/klassen/singleiter/" + id, data, {
            school_year
        });
    },
    validateKlassen(id, data) {
        return Api.putData(
            endpoint + "/klassen/singleiter/" + id + "/validate",
            data
        );
    },
    extendKlassenEntry(id, entry_id) {
        return Api.putData(
            endpoint + "/klassen/singleiter/" + id + "/extend/" + entry_id
        );
    },
    extendMultipleKlassenEntries(entry_ids) {
        return Api.putData(endpoint + "/klassen/extend", entry_ids);
    },
    extendMultipleKlassenEntriesForSingleiter(id, school_year) {
        return Api.putData(
            endpoint + "/klassen/singleiter/" + id + "/extend",
            null,
            {
                school_year
            }
        );
    },
    putOGS(id, data, school_year) {
        return Api.putData(endpoint + "/ogs/schulen/" + id, data, {
            school_year
        });
    },
    validateOGS(id, data) {
        return Api.putData(endpoint + "/ogs/schulen/" + id + "/validate", data);
    },
    extendOGSEntry(id, entry_id) {
        return Api.putData(
            endpoint + "/ogs/schulen/" + id + "/extend/" + entry_id
        );
    },
    extendMultipleOGSEntries(entry_ids) {
        return Api.putData(endpoint + "/ogs/extend", entry_ids);
    },
    extendMultipleOGSEntriesForSingleiter(id, school_year) {
        return Api.putData(endpoint + "/ogs/schulen/" + id + "/extend", null, {
            school_year
        });
    },
    putMeta(mitglied_id, key, value) {
        return Api.putData(
            endpoint + "/meta/" + key + "/mitglied/" + mitglied_id,
            value
        );
    },
    putContacts(id, data, school_year) {
        return Api.putData(endpoint + "/kontakte/singleiter/" + id, data, {
            school_year
        });
    },
    validateContacts(id, data) {
        return Api.putData(
            endpoint + "/kontakte/singleiter/" + id + "/validate",
            data
        );
    },
    extendContactEntry(id, entry_id) {
        return Api.putData(
            endpoint + "/kontakte/singleiter/" + id + "/extend/" + entry_id
        );
    },
    extendMultipleContactEntries(id, school_year) {
        return Api.putData(
            endpoint + "/kontakte/singleiter/" + id + "/extend",
            null,
            {
                school_year
            }
        );
    }
};
